import React, { useState, useEffect, useContext } from "react";
import { Grid, GridColumn, setSelectedState } from "@progress/kendo-react-grid";
import { Navigate, useNavigate } from "react-router-dom";
import { BASE_URL, userRole } from "../../../constant";
import { toast } from "react-toastify";
import axios from "axios";
import KendoLoadingPanel from "../../KendoLoadingPanel";
import AppContext from "../../../AppContext";
import { process } from "@progress/kendo-data-query";
import { DropdownFilterCell } from "./DropDownFilterCell";
import { useTranslation } from "react-i18next";
import { ReactSVG } from "react-svg";

const UserList = () => {
  const { t } = useTranslation();
  const { authCtx, superAdminCompany, darkMode } = useContext(AppContext);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState([]);

  const CategoryFilterCell = (props) => <DropdownFilterCell {...props} />;

  const roleColumn = (props) => {
    return (
      <td className="w-full">
        {userRole.find((x) => x.id === props.dataItem.role)?.name}
      </td>
    );
  };

  const boolColumn = (props) => {
    return (
      <td>
        {props.dataItem.active === true ? (
          <div className=" text-green-600 py-2">Active</div>
        ) : (
          <div className="text-red-600 py-2">Inactive</div>
        )}
      </td>
    );
  };

  const companyColumn = (props) => {
    const company = companies.find((x) => x.id === props.dataItem.companyId);
    return (
      <td>
        {props.dataItem.companyId !== null ? (
          <div className=" py-2">{company?.name}</div>
        ) : (
          <div className="text-orange-500 py-2">Company Not Assigned</div>
        )}
      </td>
    );
  };

  const loadLookupData = async () => {
    let res = await axios.get(`${BASE_URL}/api/CompanyMaster`);
    if (res.status === 200) {
      const data = res.data;
      setCompanies(data);
      return data;
    }
  };

  const loadData = async (companyData) => {
    setLoading(true);
    const companyId = authCtx.profile?.companyId;
    const res = await axios.get(
      `${BASE_URL}/UserMaster/GetAllUsers?companyId=${companyId}&userRole=${authCtx.profile.role}`
    );
    setData(res.data);
    setFilteredData(
      res.data.map((d) => ({
        ...d,
        roleName: userRole.find((r) => r.id === d.role).name,
        companyName: companyData.find((x) => x.id === d.companyId)?.name,
      }))
    );
    setLoading(false);
  };

  const onSearch = (e) => {
    setFilteredData(
      data.filter((s) =>
        s.name.toLowerCase().includes(e.target.value.toLowerCase())
      )
    );
  };

  const EditRow = (e) => {
    return (
      <td className="">
        <button className="" onClick={() => onEditClick(e)}>
          <ReactSVG
            src="EditIcon.svg"
            className="w-5 h-5 flex items-center justify-center "
            beforeInjection={(svg) => {
              svg.setAttribute(
                "style",
                `stroke: ${darkMode ? "white" : "black"}`
              );
            }}
          ></ReactSVG>
        </button>
      </td>
    );
  };

  useEffect(() => {
    const loadFns = async () => {
      loadLookupData();
      loadData(companies);
    };
    loadFns();
  }, []);

  const status = [
    { id: true, name: "Active" },
    { id: false, name: "Inactive" },
  ];

  const columns = [
    {
      field: "name",
      title: t("masters.fields.name"),
      show: true,
      width: "auto",
      filterable: true,
    },
    {
      field: "emailId",
      title: t("masters.fields.email"),
      show: true,
      width: 300,
      filterable: true,
    },
    {
      field: "mobileNumber",
      title: t("masters.fields.no"),
      show: true,
      width: 200,
      filterable: true,
    },
    {
      field: "companyName",
      title: t("masters.fields.company"),
      show: authCtx.profile.role === 100,
      width: 250,
      filterCell: (props) => CategoryFilterCell({ ...props, data: companies }),
      cell: companyColumn,
      filterable: true,
    },
    {
      field: "role",
      title: t("masters.fields.role"),
      show: true,
      width: 200,
      filterCell: (props) => CategoryFilterCell({ ...props, data: userRole }),
      cell: roleColumn,
      filterable: true,
    },
    {
      field: "active",
      title: t("masters.fields.active"),
      show: true,
      width: 150,
      filterCell: (props) => CategoryFilterCell({ ...props, data: status }),
      cell: boolColumn,
      filterable: true,
    },
    {
      field: "Action",
      title: t("masters.fields.action"),
      show: true,
      cell: EditRow,
      width: 100,
      filterable: false,
    },
  ];

  const [dataState, setDataState] = React.useState({});
  // const [stateColumns, setStateColumns] = React.useState(columns);

  const onCloseClick = (e) => {
    navigate(`/settings`);
  };
  const onEditClick = (e) => {
    setUser(e.dataItem);
    navigate(`/userform/${e.dataItem.id}`);
  };

  const onDataStateChange = (e) => {
    setDataState(e.dataState);
    setFilteredData(process(data, e.dataState));
  };

  return (
    <div className="flex flex-col text-white px-14 py-7 dark:bg-darkModeBg bg-lightModeBg h-full">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-5">
          <div className="flex text-sm font-medium gap-3 items-center">
            <button type="button" onClick={onCloseClick}>
              {/* <img src="arrow.svg" className="h-4 rotate-90" /> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2.0"
                stroke={darkMode ? "white" : "black"}
                className="w-7 h-7"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
                />
              </svg>
              {/* <ReactSVG
                  src="arrow.svg"
                  className="h-4 rotate-90 flex items-center justify-center"
                  beforeInjection={(svg) => {
                    svg.setAttribute(
                      "style",
                      `stroke: ${darkMode ? "white" : "black"}`
                    );
                  }}
                /> */}
            </button>
            <label className="text-xs lg:text-sm dark:text-white text-labels">
              {t("userProfile.settings")}
            </label>
          </div>
          <hr className="rotate-90 w-10 h-1 border-zinc-800"></hr>
          <label className="text-zinc-600 text-xs lg:text-sm font-medium">
            {t("masters.headerTexts.userMaster")}
          </label>
          <div>
            <form className="flex gap-5">
              <div className="relative dark:bg-zinc-750 bg-gray2 w-40 lg:w-80 h-9 rounded-lg dark:border-zinc-800 border focus:outline-none focus:ring-0">
                <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                  {/* <img src="search-icon.svg" className="dark:text-white text-black h-4" /> */}
                  <ReactSVG
                    src="search-icon.svg"
                    className="w-4 h-4 flex items-center justify-center"
                    beforeInjection={(svg) => {
                      svg.setAttribute(
                        "style",
                        `stroke: ${darkMode ? "white" : "black"}`
                      );
                    }}
                  ></ReactSVG>
                </div>
                <input
                  type="search"
                  id="default-search"
                  name="search"
                  className="block h-full pl-10 w-full text-xs lg:text-sm font-normal bg-inherit dark:text-white text-inputFieldsTxts dark:placeholder:text-white placeholder:text-inputPlaceHolderTxts rounded-lg"
                  placeholder={t("masters.placeholders.userSearch")}
                  onChange={onSearch}
                  required
                />
              </div>
            </form>
          </div>
        </div>
        <div className="flex gap-2 dark:text-white text-labels">
          <button
            type="button"
            onClick={() => navigate("/userform/new")}
            className="flex text-xs lg:text-sm font-medium h-9 px-2 dark:bg-indigo-700 bg-addNewItemBtns rounded-4xl justify-center items-center gap-2 leading-4"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            {t("button.addUser")}
          </button>
        </div>
      </div>
      <div
        className={`h-[74vh] mt-4 w-full mb-16 relative ${
          darkMode ? "darkGrid darkCombo" : "lightGrid lightCombo"
        }`}
        id="userList"
      >
        {loading && <KendoLoadingPanel />}
        <Grid
          style={{
            height: "100%",
            width: "100%",
            backgroundColor: "#181921",
            borderRadius: "15px",
            textAlign: "justify",
            overflowY: "auto",
            scrollbarGutter: "auto",
            scrollBehavior: "smooth",
            scrollbarWidth: "auto",
          }}
          data={filteredData}
          scrollable={{ virtual: true, scrollMode: "scrollable" }}
          onRowDoubleClick={onEditClick}
          onDataStateChange={onDataStateChange}
          resizable
          {...dataState}
          filterable
        >
          {columns.map(
            (column, idx) =>
              column.show && (
                <GridColumn
                  key={idx}
                  field={column.field}
                  title={column.title}
                  filterable={column.filterable}
                  cell={column.cell}
                  width={column.width}
                  filterCell={column?.filterCell}
                  className="product-name"
                />
              )
          )}
        </Grid>
        <br />
      </div>
    </div>
  );
};

export default UserList;
